import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { fetchPackageTypes, editPackageType, clearPackageTypeEdited, deletePackageType } from '../../actions/products_actions';
import { PackageTypes } from '../../components/Products/packageTypes';

let packageTypes = reduxForm({
  form: 'packageTypes',
})(PackageTypes);

function mapStateToProps(state) {
  return {
    packageTypesFetched: state.products.packageTypesFetched,
    fetchingPackageTypes: state.products.fetchingPackageTypes,
    packageTypeFetchError: state.products.packageTypeFetchError,
    editingPackageTypes: state.products.editingPackageTypes,
    packageTypesEdited: state.products.packageTypesEdited,
    packageTypeEditError: state.products.packageTypeEditError,
    deletingPackageTypes: state.products.deletingPackageTypes,
    deletePackageTypesSuccess: state.products.deletePackageTypesSuccess, 
    deletePackageTypesError: state.products.deletePackageTypesError,
  }
}

export default connect(mapStateToProps, {
  fetchPackageTypes, editPackageType, clearPackageTypeEdited, deletePackageType
})(packageTypes)



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/packageTypes.jsx